/**
 * @generated SignedSource<<2ae160d085c710b19f9f6b8dfd00f340>>
 * @relayHash ee86c78537c1355af4f72c5f50c1f303
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 24fdf55a6a9a3f4540591340bc11bb50d456ae16e3f89daea15313a6e0b1c373

import type { ConcreteRequest } from 'relay-runtime';
export type useContentReportTableDataQuery$variables = {
  cql: string;
  first?: number | null | undefined;
  includeComments: boolean;
  includeLikes: boolean;
};
export type useContentReportTableDataQuery$data = {
  readonly search: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly comments?: {
          readonly count: number | null | undefined;
        } | null | undefined;
        readonly creatorId: string | null | undefined;
        readonly history: {
          readonly createdBy: {
            readonly displayName: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly likes?: {
          readonly count: number | null | undefined;
        } | null | undefined;
        readonly space: {
          readonly key: string | null | undefined;
        } | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly lastModified: string | null | undefined;
      readonly title: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useContentReportTableDataQuery = {
  response: useContentReportTableDataQuery$data;
  variables: useContentReportTableDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cql"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeComments"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeLikes"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cql",
    "variableName": "cql"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "url"
},
v4 = {
  "kind": "ScalarField",
  "name": "lastModified"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "creatorId"
},
v8 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v9 = [
  {
    "kind": "ScalarField",
    "name": "count"
  }
],
v10 = {
  "condition": "includeComments",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "PaginatedContentList",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": (v9/*: any*/)
    }
  ]
},
v11 = {
  "condition": "includeLikes",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "LikesResponse",
      "kind": "LinkedField",
      "name": "likes",
      "plural": false,
      "selections": (v9/*: any*/)
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "key"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentReportTableDataQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentReportTableDataQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ee86c78537c1355af4f72c5f50c1f303",
    "id": "24fdf55a6a9a3f4540591340bc11bb50d456ae16e3f89daea15313a6e0b1c373",
    "metadata": {},
    "name": "useContentReportTableDataQuery",
    "operationKind": "query",
    "text": "query useContentReportTableDataQuery($cql:String!,$first:Int,$includeComments:Boolean!,$includeLikes:Boolean!){search:confluence_search(cql:$cql,first:$first){nodes{title,url,lastModified,content{id,type,creatorId,history{createdBy{__typename,displayName}},comments@include(if:$includeComments){count},likes@include(if:$includeLikes){count},space{key,id}}}}}"
  }
};
})();

(node as any).hash = "5091664a9f54a927ae78ac6ba80de437";

export default node;
